import { useMemo } from 'react';
import { useAccountDataQuery } from 'queries/account';

export const useAiAgentFeatureFlag = (): boolean => {
  const { data: accountData } = useAccountDataQuery();

  const accountMeta = accountData?.accountMeta;

  const hasAiAgentFeatures = useMemo(() => {
    return accountMeta?.features?.aiAgents ?? false;
  }, [accountMeta?.features]);

  return hasAiAgentFeatures;
};
